/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { SetAirConditionerCharacteristicPayload } from 'api/actions/set-air-conditioner-characteristic/set-air-conditioner-characteristic-payload';
import { SetAirConditionerCharacteristicPathParameters } from 'api/actions/set-air-conditioner-characteristic/set-air-conditioner-characteristic-path-parameters';
import { SetAirConditionerCharacteristicResponse } from 'api/actions/set-air-conditioner-characteristic/set-air-conditioner-characteristic-response';

type SetAirConditionerCharacteristicQueryParameters = Record<string, any>;

/**
 * The path of the SetAirConditionerCharacteristic action.
 */
export const setAirConditionerCharacteristicActionPath = new SweetPath<
  keyof SetAirConditionerCharacteristicPathParameters
>('/air-conditioners/{airConditionerId}/characteristics/{characteristicName}', { path: '{param}' });

/**
 * Creates a contextualized SetAirConditionerCharacteristic actions.
 */
export default function createSetAirConditionerCharacteristicAction(axios: AxiosInstance) {
  return function setAirConditionerCharacteristicAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: SetAirConditionerCharacteristicPathParameters;
    query?: SetAirConditionerCharacteristicQueryParameters;
    payload: SetAirConditionerCharacteristicPayload;
  }) {
    const path = setAirConditionerCharacteristicActionPath.insert(parameters);

    return axios.patch<
      SetAirConditionerCharacteristicResponse,
      SetAirConditionerCharacteristicResponse,
      SetAirConditionerCharacteristicPayload
    >(path, payload);
  };
}
